import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=46c67fe4&scoped=true&"
import script from "./ProductsList.vue?vue&type=script&lang=js&"
export * from "./ProductsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=46c67fe4&lang=scss&scoped=true&"
import style1 from "./ProductsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c67fe4",
  null
  
)

export default component.exports